<template>
  <div class="g2r-simulateur-empreinte-carbone" v-cloak>
    <section>
      <div class="g2r-simulateur-empreinte-carbone-row">
        <div>
          <label for="kms">Nombre de kilomètres</label>
          <input id="kms" v-model="kms" type="number" min="0" step="1">
        </div>
        <div>
          <label for="count">Nombre de véhicules dans votre flotte</label>
          <input id="count" v-model="vehicleCount" type="number" min="0" step="1">
        </div>
      </div>
      <div class="g2r-simulateur-empreinte-carbone-row">
        <div>
          <div class="g2r-simulateur-empreinte-carbone-vehicle g2r-simulateur-empreinte-carbone-vehicle-thermal">
            <ThermalVehicle/>
            <div>Thermique</div>
          </div>
        </div>
        <div>
          <label for="costThermal50Cc">Coût du carburant 50 cm3</label>
          <input id="costThermal50Cc" :value="thermiquePrix + '€'" type="text" disabled>
        </div>
        <div>
          <label for="costThermal125Cc">Coût du carburant 125 cm3</label>
          <input id="costThermal125Cc" :value="thermiquePrix + '€'" type="text" disabled>
        </div>
        <div>
          <label for="countThermalCO2">Nombre de tonnes de CO2</label>
          <input id="countThermalCO2" :value="thermiqueCO2" type="text" disabled>
        </div>
      </div>
      <div class="g2r-simulateur-empreinte-carbone-row">
        <div>
          <div class="g2r-simulateur-empreinte-carbone-vehicle g2r-simulateur-empreinte-carbone-vehicle-electric">
            <ElectricVehicle/>
            <div>Electrique</div>
          </div>
        </div>
        <div>
          <label for="costElectric50Cc">Coût des recharges 50 cm3</label>
          <input id="costElectric50Cc" :value="eletrique50Prix + '€'" type="text" disabled>
        </div>
        <div>
          <label for="costElectric125Cc">Coût des recharges 125 cm3</label>
          <input id="costElectric125Cc" :value="eletrique125Prix + '€'" type="text" disabled>
        </div>
        <div>
          <label for="countElectricCO2">Nombre de tonnes de CO2</label>
          <input id="countElectricCO2" value="0" type="text" disabled>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ThermalVehicle from "../../icons/ThermalVehicle.vue";
import ElectricVehicle from "../../icons/ElectricVehicle.vue";

export default {
  name: "EmpreinteCarbone",
  components: {ThermalVehicle, ElectricVehicle},
  data() {
    return {
      kms: 5000,
      vehicleCount: 1
    }
  },
  computed: {
    thermiquePrix: function () {
      /**
       * Le tarif moyen du SP95 doit tourner autour des 1.65 €.
       * Un 50 ou 125 thermique consommera 3 litres au 100 kilomètres.
       */
      return Math.round(this.kms * 3 / 100 * 1.65) * this.vehicleCount;
    },
    thermiqueCO2: function () {
      /**
       * 20 000 km > 10 tonnes.
       * 10 000 km > 5 tonnes.
       * 5 000 km > 2.5 tonnes.
       */
      return (this.kms * 0.0005 * this.vehicleCount).toFixed(2);
    },
    eletrique50Prix: function () {
      /**
       * Un 50 électrique consommera 3kWh au 100 kilomètres.
       * Le tarif réglementaire EDF est de 0.1558 € TTC au kWh.
       */
      return Math.round(this.kms * 3 / 100 * 0.1558) * this.vehicleCount;
    },
    eletrique125Prix: function () {
      /**
       * Un 125 électrique consommera 4 kWh au 100 kilomètres.
       * Le tarif réglementaire EDF est de 0.1558 € TTC au kWh.
       */
      return Math.round(this.kms * 4 / 100 * 0.1558) * this.vehicleCount;
    }
  }
}
</script>

<style scoped lang="scss">

[v-cloak] {
  display: none;
}

.g2r-simulateur-empreinte-carbone {
  clear: both;
  background-color: #aab54d;
  background-image: radial-gradient(#d2e160, transparent);
  color: white;
  margin-bottom: 3rem;
  padding: 3rem 2rem;
  font-size: 85%;
  max-width: calc(100vw - 60px);

  &-vehicle {
    text-align: center;
    border-radius: 100%;
    width: 130px;
    height: 130px;

    svg {
      margin-top: .5rem;
    }

    & > div {
      margin-top: -3rem;
      font-size: 2rem;
    }

    &-thermal {
      background-color: #a6a6a6;
    }

    &-electric {
      background-color: #6cbf77;
    }
  }

  &-row {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 130px;

    &:first-child {
      height: 80px;
    }

    &:not(:last-child) {
      margin-bottom: 6px;
    }

    & > div:first-child {
      min-width: 150px;
    }

    & > div:not(:first-child) {
      width: 200px;
      flex-grow: 1;
    }

    & > div {
      padding-right: 6px;
    }

    & > div:last-child {
      padding-right: 0px;
    }
  }
}

@media screen and (max-width: 1023px) {
  .g2r-simulateur-empreinte-carbone {
    &-row {
      &:first-child {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 80px;
        padding-bottom: 12px;
        margin-bottom: 12px;

        & > div:first-child {
          display: none;
        }

        & > div:not(:first-child) {
          padding-right: 6px;
        }

        & > div:last-child {
          padding-left: 6px;
          padding-right: 0px;
        }
      }

      &:not(:first-child) {
        display: inline-block;
        width: 50%;
        text-align: center;
        padding-right: 6px;
      }

      &:last-child {
        padding-left: 6px;
        padding-right: 0px;
      }

      & > div:first-child {
        & > div {
          margin: 0 auto 12px auto;
        }
      }

      & > div:not(:first-child) {
        width: 100%;
      }

      & > div:last-child {
        padding-left: 0px;
      }

      & > div {
        padding: 0px;
      }
    }
  }
}

</style>
